import { render, staticRenderFns } from "./mainreserved.vue?vue&type=template&id=d377047c&scoped=true&"
import script from "./mainreserved.vue?vue&type=script&lang=js&"
export * from "./mainreserved.vue?vue&type=script&lang=js&"
import style0 from "./mainreserved.vue?vue&type=style&index=0&id=d377047c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d377047c",
  null
  
)

export default component.exports